import React from "react";

const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_aesthetic-notebooks/artifacts/67jt161t_2DB1BD79-63E1-4FC8-903C-24710CA6CCD7.png";

/**
 * BrandMark — official Dar al Midad seal logo.
 * Variants:
 *   - "wordmark"   : compact horizontal text-only mark for navbar/footer
 *   - "icon-only"  : the round seal logo (small)
 *   - "stacked"    : large hero seal with tagline below
 *
 * The seal already contains the full visual identity (icon, name, Arabic,
 * decorative ring), so we present it cleanly without extra framing.
 */
export default function BrandMark({
    variant = "wordmark",
    size = "md",
    className = "",
    testId = "brand-mark",
}) {
    if (variant === "wordmark") {
        const sizeMap = {
            sm: "text-lg",
            md: "text-xl",
            lg: "text-2xl",
        };
        return (
            <span
                data-testid={testId}
                className={`inline-flex items-baseline gap-2 ${className}`}
            >
                <span
                    className={`font-serif font-medium tracking-tight text-ink-900 ${sizeMap[size]}`}
                >
                    Dar
                </span>
                <span
                    className={`font-serif italic font-light text-mauve-500 ${sizeMap[size]}`}
                >
                    al
                </span>
                <span
                    className={`font-serif font-medium tracking-tight text-ink-900 ${sizeMap[size]}`}
                >
                    Midad
                </span>
            </span>
        );
    }

    if (variant === "icon-only") {
        const dim =
            size === "lg"
                ? "w-40 h-40 md:w-48 md:h-48"
                : size === "sm"
                  ? "w-11 h-11"
                  : "w-24 h-24";
        return (
            <img
                src={LOGO_URL}
                alt="Dar al Midad Siegel"
                data-testid={testId}
                className={`${dim} rounded-full object-cover ${className}`}
            />
        );
    }

    // stacked (hero)
    return (
        <div
            data-testid={testId}
            className={`flex flex-col items-center text-center ${className}`}
        >
            {/* The seal already contains the full lockup */}
            <img
                src={LOGO_URL}
                alt="Dar al Midad — Haus der Tinte"
                className="w-72 h-72 md:w-[22rem] md:h-[22rem] rounded-full object-cover shadow-[0_40px_80px_-30px_rgba(166,138,154,0.45)]"
            />

            {/* Hairline divider */}
            <div className="mt-10 flex items-center gap-3 text-mauve-500">
                <span className="block h-px w-12 bg-mauve-500/40" />
                <span className="text-[8px] tracking-[0.5em] uppercase">
                    Est.2026 ✦
                </span>
                <span className="block h-px w-12 bg-mauve-500/40" />
            </div>

            {/* Tagline */}
            <p className="mt-5 text-[10px] tracking-[0.42em] uppercase text-ink-500 font-light">
                Haus · der · Tinte
            </p>
        </div>
    );
}
